module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/y4ctOY/tc-custom/9781479869954.jpg?1719927329526",
      "alt": "This image is the cover for the book Structure of Production, North American Religions"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Structure of Production, North American Religions\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 2014, the U. S. government adopted a new quarterly statistic called gross output (GO), the most significance advance in national income accounting since gross domestic product (GDP) was developed in the 1940s.  The announcement came as a triumph for Mark Skousen, who advocated GO nearly 25 years ago as an essential macroeconomic tool and a better way to measure the economy and the business cycle.   Now it has become an official statistic issued quarterly by the Bureau of Economic Analysis at the U. S. Department of Commerce. "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("In this new revised edition of Structure of Production, Skousen shows why GO is a more accurate and comprehensive measure of the economy because it includes business-to-business transactions that move the supply chain along to final use.  (GDP measures the value of finished goods and services only, and omits B-to-B activity.)  GO is an attempt to measure spending at all stages of production.  Using GO, Skousen demonstrates that the supply-side of the business spending is far more important than consumer spending, is more consistent with economic growth theory, and a better measure of the business cycle.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Skousen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New York University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0